<div *ngIf="status !== null">
  <div *ngIf="status === 0" title="Пешком" class="cur-help">
    <app-icon [glyph]="'walk'" [size]="'16'" [color]="'gray'" [class]="'icon--va-middle'"></app-icon>
  </div>
  <div *ngIf="status === 1" title="На машине" class="cur-help">
    <app-icon [glyph]="'auto'" [size]="'16'" [color]="'gray'" [class]="'icon--va-middle'"></app-icon>
  </div>
</div>
